import styled from "styled-components";

export const KeyBtnWrapper = styled.div`
  margin-right: 0.75rem;
`;
